import {
  Chip,
  ChipColorEnum,
  ChipShapeEnum,
  ChipSizeEnum,
  FontColorEnum,
  FontSizeEnum,
  FontWeightEnum,
  LoaderIcon,
  Typography,
} from '@acceso/design-system';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { LimitDisplay } from '@/components/LimitDisplay/LimitDisplay';
import { groupItemsByKeywords } from '@/features/broadcast-schedule-program/helpers/group-by-id';
import { TSegmentMention } from '@/features/segments/types';

import { MentionsAssigmentsTooltip } from '../MentionsAssigmentsTooltip';

type ShowMentionsProps = {
  mentions: TSegmentMention[];
};

export function ShowMentions({
  mentions,
  isLoadingPreview,
}: ShowMentionsProps & { isLoadingPreview?: boolean }) {
  const { t } = useTranslation();

  const groupedKeywords = useMemo(() => groupItemsByKeywords(mentions), [mentions]);

  return (
    <div>
      <div className="flex justify-between gap-2">
        <div className="flex items-center gap-1">
          <Typography
            weight={FontWeightEnum.Bold}
            fontSize={FontSizeEnum.Lg}
            color={FontColorEnum.Medium20}
          >
            {t('Previsión de Keywords')}:
          </Typography>
          <Typography
            fontSize={FontSizeEnum.Lg}
            color={FontColorEnum.Medium20}
            weight={FontWeightEnum.Semibold}
          >
            {groupedKeywords.length}
          </Typography>
          <MentionsAssigmentsTooltip />
        </div>
      </div>
      {isLoadingPreview ? (
        <div className="flex w-full justify-center">
          <LoaderIcon className="animate-spin" />
        </div>
      ) : (
        <LimitDisplay
          items={groupedKeywords}
          limit={15}
          renderItem={item => (
            <Chip
              key={item.id}
              color={ChipColorEnum.GHOST}
              shape={ChipShapeEnum.ROUNDED}
              size={ChipSizeEnum.SM}
            >
              {item.id}
            </Chip>
          )}
          renderTooltip={items => (
            <div className="flex flex-wrap gap-1">
              {items.map(item => (
                <Chip
                  key={item.id}
                  color={ChipColorEnum.GHOST}
                  shape={ChipShapeEnum.ROUNDED}
                  size={ChipSizeEnum.SM}
                >
                  {item.id}
                </Chip>
              ))}
            </div>
          )}
        />
      )}
    </div>
  );
}
